import {createContext, useContext, useState} from "react";

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [type, setType] = useState("success");
  const [message, setMessage] = useState("");
  const [response, setResponse] = useState(null);

  const onOpen = (type, message) => {
    setType(type);
    setMessage(message);
    setIsOpen(true);
  };

  const onClose = () => {
    setIsOpen(false);
    setMessage("");
    setResponse(null);
  };

  const setResponseData = (data) => {
    setResponse(data);
  };

  return (
    <AlertContext.Provider 
      value={{ 
        isOpen, 
        type, 
        message, 
        response,
        onOpen, 
        onClose,
        setResponseData 
      }}
    >
      {children}
    </AlertContext.Provider>
  );
};

export const useAlertContext = () => {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error("useAlertContext must be used within an AlertProvider");
  }
  return context;
};
